import React from "react";

export default function Page_1() {
    return(
        <div>
            Page 1
        </div>
    )
}